module.exports = ort-wasm-simd-threaded.wasm;